import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const LegalNavigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();

  const navItems = [
    { id: 'home', label: 'Accueil' },
    { id: 'about', label: 'Qui sommes-nous ?' },
    { id: 'contact', label: 'Nous contacter' },
    { id: 'prysme', label: 'Prysme le groupe' }
  ];

  const handleNavigationClick = (sectionId) => {
    // Navigate to homepage and scroll to section
    navigate('/', { 
      state: { scrollToSection: sectionId }
    });
    setIsOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm border-b border-gray-200 z-50">
      <div className="w-full px-2 sm:px-4 lg:px-6 xl:px-8">
        <div className="flex justify-between items-center h-12 sm:h-14 lg:h-16">
          {/* Logo responsive */}
          <div className="flex-shrink-0">
            <button
              onClick={() => navigate('/')}
              className="transition-transform duration-300 hover:scale-105"
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_sisens-cuisine/artifacts/3lootc7r_25.04.10%20SISENS%20LOGO.png" 
                alt="SISENS Logo" 
                className="h-6 sm:h-8 lg:h-10 xl:h-12 w-auto"
              />
            </button>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:block">
            <div className="ml-4 lg:ml-10 flex items-baseline space-x-2 lg:space-x-6 xl:space-x-8">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => handleNavigationClick(item.id)}
                  className="px-2 lg:px-3 py-2 text-xs lg:text-sm xl:text-base font-medium transition-all duration-300 text-gray-700 hover:text-[#e71f74]"
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="p-2 text-gray-700 hover:text-[#e71f74] transition-colors duration-300"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden bg-white border-t border-gray-200">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => handleNavigationClick(item.id)}
                  className="block w-full text-left px-3 py-2 text-base font-medium transition-colors duration-300 text-gray-700 hover:text-[#e71f74] hover:bg-gray-50"
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default LegalNavigation;